import { render } from "./ReporteInsumos.vue?vue&type=template&id=4e01d6a3&scoped=true"
import script from "./ReporteInsumos.vue?vue&type=script&lang=js"
export * from "./ReporteInsumos.vue?vue&type=script&lang=js"

import "./ReporteInsumos.vue?vue&type=style&index=0&id=4e01d6a3&scoped=true&lang=scss"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e01d6a3"]])

export default __exports__